// Чистые функции для центра уведомлений: группировка по дням, «5 мин назад», метки уровней.

const MSK_OFFSET_MS = 3 * 60 * 60 * 1000;

export function itemTime(item) {
  return new Date(item.updated_at || item.created_at).getTime();
}

// Номер календарного дня по Москве: так «сегодня» не зависит от часового пояса браузера.
function mskDayNumber(ms) {
  return Math.floor((ms + MSK_OFFSET_MS) / 86400000);
}

export function dayGroupLabel(ms, nowMs) {
  const diff = mskDayNumber(nowMs) - mskDayNumber(ms);
  if (diff <= 0) return 'Сегодня';
  if (diff === 1) return 'Вчера';
  return 'Раньше';
}

export function groupByDay(items, nowMs = Date.now()) {
  const order = ['Сегодня', 'Вчера', 'Раньше'];
  const groups = new Map(order.map((label) => [label, []]));
  [...items]
    .sort((a, b) => itemTime(b) - itemTime(a))
    .forEach((item) => groups.get(dayGroupLabel(itemTime(item), nowMs)).push(item));
  return order.map((label) => ({ label, items: groups.get(label) })).filter((group) => group.items.length > 0);
}

export function relativeTime(ms, nowMs = Date.now()) {
  const seconds = Math.max(0, Math.round((nowMs - ms) / 1000));
  if (seconds < 60) return 'только что';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} мин назад`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} ч назад`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} дн. назад`;
  return new Date(ms).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', timeZone: 'Europe/Moscow' });
}

export const LEVEL_LABEL = { info: 'Информация', success: 'Готово', warning: 'Важно', error: 'Ошибка' };
export const LEVEL_ICON = { info: 'i', success: '✓', warning: '!', error: '×' };
